
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/publishing/scheduler/feed-preview",
      function () {
        return require("private-next-pages/publishing/scheduler/feed-preview.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/publishing/scheduler/feed-preview"])
      });
    }
  